<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'px-6': mobile,
          'pt-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">Transfer Tenant</p>
        <v-form>
          <v-row>
            <v-col class="pb-0" cols="12" sm="12" md="12">
              <v-select
                v-model="bedId"
                :items="bedsList"
                label="Unit"
                prepend-inner-icon="mdi-bed-empty"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            :disabled="!Number.isInteger(bedId)"
            text
            @click="finish"
          >
            Finish
          </v-btn>
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    bedsList: [],
    bedId: -1,
    dialog: false,
    resolve: null,
    reject: null,
    options: {
      color: 'primary',
      width: 500,
      zIndex: 200
    },
    date: new Date().toISOString().substr(0, 10),
    loading: true,
    oldBed: {}
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    units() {
      return this.$store.getters['units/getUnitsFlat']
    },
    currentProperty() {
      return this.$store.getters['auth/getUser'].selectedProperty
    }
  },
  watch: {
    date() {
      this.moveInDate = this.formatDate(this.date)
    }
  },
  methods: {
    async open(params) {
      this.loading = true
      this.dialog = true

      await this.$store.dispatch('units/fetchUnitsFlatAction', {
        propertyId: this.currentProperty.propertyId
      })

      this.oldBed = params
      this.loading = false
      this.bedsList = this.units
        .filter((unit) => unit.bedId && unit.status === 'vacant')
        .sort((a, b) => a.bedName.localeCompare(b.bedName))
        .map((unit) => ({
          value: unit.bedId,
          text: unit.bedName
        }))

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      // this.resolve(false)
      this.dialog = false
    },
    async finish() {
      this.loading = true

      await this.$store.dispatch('units/transferTenantAction', {
        tenantId: this.oldBed.tenantId || this.oldBed.lease_details.tenantId,
        newBedId: this.bedId,
        oldBedId: this.oldBed.bedId,
        leaseId: this.oldBed.leaseId
      })

      this.loading = false
      this.dialog = false
      this.$root
        .$confirm({
          title: 'Transfer Bed',
          message: `Tenant has been tranferred.`,
          reconfirmOnly: true,
          confirmText: 'OK'
        })
        .then(async () => {
          this.resolve(true)
        })
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  }
}
</script>
